import { DictionaryNamesEnum } from '../enums/DictionaryNamesEnum';

export const getDictionaryKey = (dictionaryName: DictionaryNamesEnum, constraintUUIDs?: string[]) =>
  `${dictionaryName}/${constraintUUIDs?.length ? constraintUUIDs.join('/') : ''}`.replace(`//`, `/`);
